import wsb_transitory_bg from './files/wsb_transitory_bg.jpg'
import wsb_logo_landing from './files/wsb_logo_landing.png'
import leveraged_gaming_text from './files/leveraged_gaming-text.png'
import powered_by_yolorekt_landing from './files/powered_by_yolorekt-landing.png'

export const resources = {
  wsb_transitory_bg,
  wsb_logo_landing,
  leveraged_gaming_text,
  powered_by_yolorekt_landing,
}
